<template>
  <div class="leftCardContainer">
    <div class="rightSideTitleActions">
      <span class="leftTitle">{{ $tc('User', 2) }}</span>
      <div class="actionsContainer">
        <div class="searchContainer">
          <v-icon> search </v-icon>
          <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
            borderRadius: '0px',
            width: '130px',
            borderTop: 'none',
            borderRight: 'none',
            borderLeft: 'none',
            borderBottom: '1px solid rgba(118, 118, 118, 0.50)',
          }" @input="handleSearch($event)" />
        </div>
        <CustomButton icon="download" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" @buttonClick="handleDownload" :disabled="true" />
        <CustomButton icon="add" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" :disabled="!userHasPermission('role_store') || userIsCreatingOrEditingData" @buttonClick="handleAdd" />
        <CustomButton v-if="isSuperAdmin" icon="delete" :width="'20px'" :height="'20px'" :iconSize="12"
          :buttonStyling="{ padding: '8px', marginRight: '5px', borderRadius: '4px' }" :disabled="!isSuperAdmin || !selectedUser" @buttonClick="openDeleteDialog" />
      </div>
    </div>
    <div class="tabsContainer">
      <Tabs :activeTab="activeTab" :tabs="tabs" :centerTabs="false" @startTabChange="handleTabChange" />
    </div>
    <div class="tableDivContainer">
      <Table :checkbox="false" :loading="loading" :headers="headers" :items="users" :sortable="true"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="true"
      />
    </div>
    <DialogContent :isOpen="dialog" :isPersistent="false" :onClose="closeDialog">
      <template v-slot:content>
        <div style="height: 100%;">
          <div class="tabs-custom">
            <Tabs :tabs="tabsDialog" :activeTab="activeTabDialog" @startTabChange="handleTabChangeDialog"
              style="display: flex; align-items: left;" />
          </div>
          <div class="tabs-content-custom" v-if="activeTabDialog === 0">
            <span class="span-custom">Material Family</span>
            <InputField :inputStyle="{
              backgroundColor: 'white',
            }" inputType="text" value="All Families" size="large" :inputDisabled="true"></InputField>
            <InputField :inputStyle="{
              color: '#767676 !important',
            }" inputType="file" size="large" :fileTypes="fileTypes" :value="file" @input="updateFile($event)">
            </InputField>
            <div class="buttons-container-custom">
              <div style="display: flex">
                <CustomButton :label="$t('Download Materials')" :width="'4.48438rem'"
                  :button-styling="customButtonStylesExtra" @buttonClick="handleExtraAction"></CustomButton>
              </div>
              <div style="display: flex">
                <CustomButton :label="$t('Cancel')" :width="'2.74219rem'" :button-color="'#FFF'" :label-color="'#29BDF0'"
                  :buttonStyling="customButtonStylesSecondary" @buttonClick="handleSecondaryAction"></CustomButton>
                <CustomButton :label="$t('Submit')" :width="'2.74219rem'" :button-styling="customButtonStylesMain"
                  @buttonClick="handleMainAction(file)">
                </CustomButton>
              </div>
            </div>
          </div>
          <div class="table-buttons-custom" v-if="activeTabDialog === 1">
            <div class="table-custom">
              <Table :loading="loading" :headers="headersDialog" :items="history"></Table>
            </div>
            <div>
              <div style="display: flex; justify-content: flex-end">
                <CustomButton :buttonStyling="customButtonStylesSecondary" :label="$t('Close')"
                  @buttonClick="handleSecondaryAction">
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
        <LoadingSpinner :active.sync="loadingUpload" :is-full-page="false" color="#29bdf0" />
      </template>
    </DialogContent>
    <dialog-choice :isOpen="deleteDialogIsOpen" :title="$t('DeleteUser')" :content="$t('DeleteUserConfirmation')"
      :mainActionLabel="$t('Confirm')" @mainAction="handleDelete" :secondaryActionLabel="$t('Cancel')"
      @secondaryAction="deleteDialogIsOpen = false" icon="mdi-delete" iconColor="#29BDF0" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import Table from "@/newComponents/_Molecules/Table.vue";
import CustomButton from "@/newComponents/_Atoms/CustomButton.vue";
import InputField from "@/newComponents/_Atoms/InputField.vue";
import Tabs from "@/newComponents/_Atoms/Tabs.vue";
import DialogContent from "@/newComponents/_Molecules/DialogContent.vue";
import LoadingSpinner from "vue-loading-overlay";
import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "TableView",

  props:{

    selectedUser: {
      type: Object,
    },

  },

  mixins: [ checkPermissionsMixin ],

  components: {
    Table,
    ManagementPage,
    CustomButton,
    InputField,
    Tabs,
    DialogContent,
    LoadingSpinner,
    DialogChoice,
  },

  data() {
    return {
      availableWebUsers: null,
      availableWebViewerUsers: null,
      availableMobileUsers: null,
      availableMobileViewerUsers: null,
      maxWebUsers: null,
      maxWebViewerUsers: null,
      maxMobileUsers: null,
      maxMobileViewerUsers: null,
      dialog: false,
      deleteDialogIsOpen: false,
      loadingUpload: false,
      activeTabDialog: 0,
      tabsDialog: [
        {
          label: this.$i18n.t("Import"),
        },
        {
          label: this.$i18n.t("History"),
        },
      ],
      value: null,
      fileTypes: [".xlsx"],
      type: "normal",

      history: [],
      file: [],
      search: null,
      activeTab: 0,
      loading: false,
      userType: 'web',
      scrollTop: 0,
      sortOrder: null,
      scrollHeight: 0,
      selectedRows: [],
      pageNumber: 1,
      pagination: 25,
      currentPageTop: 1,
      currentPageBot: 1,
      lastPage: 2,
      headers: [
        { text: this.$i18n.tc("Name", 1), varName: "name" },
        { text: this.$i18n.tc("Username", 1), varName: "username" },
        { text: this.$i18n.tc("Email", 1), varName: "email" },
        { text: this.$i18n.tc("Role", 1), varName: "role_name" },
        { text: this.$i18n.tc("Status", 1), varName: "status" },
        { text: this.$i18n.tc("CreationDate", 1), varName: "created_at" },
      ],
      users: [],
      customButtonStylesSecondary: {
        'marginRight': '10px',
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      customButtonStylesMain: {
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      customButtonStylesExtra: {
        'marginTop': '10px',
        'boxShadow': 'none',
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '0.4375rem',
        'line-height': '0.75rem',
        'height': '20px',
        'font-weight': '600'
      },
      userIsCreatingOrEditingData: false,
    };
  },

  mounted() {
    this.loadHistory();
    // this.getAllUsers();
    this.getAvailableUsers();
    this.getInitialUsers();
    bus.$on("reload-users", () => {
      this.getInitialUsers();
      this.getAvailableUsers();
    });
    bus.$on("toggle-create-edit-flag", () => this.userIsCreatingOrEditingData = !this.userIsCreatingOrEditingData)
  },

  destroyed() {
    bus.$off("reload-users");
    bus.$off("create-new-user")
    bus.$off("toggle-create-edit-flag");
  },

  computed: {
    tabs() {
      const tabsArray = [
        { label: `Web (${this.availableWebUsers})` },
        { label: `Mobile (${this.availableMobileUsers})` },
        { label: `Web Viewers (${this.availableWebViewerUsers})` },
        { label: `Mobile Viewers (${this.availableMobileViewerUsers})` },
      ];

      // Check and include max users if available
      if (this.maxWebUsers !== null) {
          tabsArray[0].label = `Web (${this.availableWebUsers}/${this.maxWebUsers})`;
      }
      if (this.maxMobileUsers !== null) {
          tabsArray[1].label = `Mobile (${this.availableMobileUsers}/${this.maxMobileUsers})`;
      }
      if (this.maxWebViewerUsers !== null) {
          tabsArray[2].label = `Web Viewers (${this.availableWebViewerUsers}/${this.maxWebViewerUsers})`;
      }
      if (this.maxMobileViewerUsers !== null) {
          tabsArray[3].label = `Mobile Viewers (${this.availableMobileViewerUsers}/${this.maxMobileViewerUsers})`;
      }

      return tabsArray;
    },

    deleteButtonDisable() {
      return !this.selectedUser || Object.keys(this.selectedUser).length === 0;
    }
  },

  watch: {
    activeTabDialog(value) {
      if (value === 1) {
        this.loadHistory();
      }
    }
  },

  methods: {
    ...mapActions(["fetchStockMaterialsListObject", "getHistory", "DELETE_USER_BY_ID", "downloadAll", "importMaterialFamilies", "fetchAvailableUsers", "fetchAllUsers"]),

    /**
     * Get the number of available users
     * @returns {Promise<void>}
     */
    async getAvailableUsers() {
      try {
        let resp = await this.fetchAvailableUsers();
        let users = resp.data.data;
        this.availableWebUsers = users.webUsed;
        this.maxWebUsers = users.webMax;
        this.availableWebViewerUsers = users.webViewerUsed;
        this.maxWebViewerUsers = users.webViewerMax;
        this.availableMobileUsers = users.mobileUsed;
        this.maxMobileUsers = users.mobileMax;
        this.availableMobileViewerUsers = users.mobileViewerUsed;
        this.maxMobileViewerUsers = users.mobileViewerMax;
      } catch (error) {
        console.error(error);
      }
    },


    handleTabChangeDialog(index) {
      this.activeTabDialog = index;
    },

    async loadHistory() {
      try {
        const history = await this.getHistory();
        this.history = history;
        this.history = history.map((item) => ({
          ...item,
          materialFamily: item.material_family || "All Families",
        }))
      } catch (e) {
        console.error(e);
      }
    },

    closeDialog() {
      this.dialog = false;
    },

    async handleMainAction() {
      this.loadingUpload = true;

      try {

        let formData = new FormData();

        formData.append("file", this.file);
        formData.append("file_type", "xlsx");

        // Make the HTTP request to upload the file
        await this.importMaterialFamilies(formData);

        this.$toasted.global.toast_success(this.$i18n.t("FileUploadedSuccessfully"));
      } catch (e) {
        console.error(e);
        this.$toasted.global.toast_error(this.$i18n.t("FileUploadError"));
      } finally {
        this.loadingUpload = false;
        bus.$emit("clear-drop-button-file")
        this.closeDialog();
        this.getInitialUsers();
      }
    },

    handleSecondaryAction() {
      bus.$emit("clear-drop-button-file")
      this.closeDialog();
      setTimeout(() => {
        this.activeTabDialog = 0;
      }, 1000);
    },
    handleExtraAction() {
      this.handleDownload();
    },

    updateFile(e) {
      this.file = e
    },

    async getInitialUsers() {
      this.loading = true;
      this.currentPageBot = 1
      this.currentPageTop = 1
      let queryParams = {
        "page[number]": 1,
        paginate: 25,
        userType: this.userType,
      };

      if (this.search !== null) {
        queryParams["search"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }
      const usersObject = await this.fetchAllUsers(queryParams);
      this.users = usersObject.data.data;
      this.users.forEach(user => {
        user.name = user.name;
        user.status = user.status ? 'Active' : 'Not Active';
        user.role_name = user.role.name ? user.role.name : 'No Role';
        this.userType = user.type;
      });
      this.lastPage = usersObject.data.meta.last_page;
      this.loading = false;
    },

    async getUsersBottom() {
      this.loading = true;
      this.pagination = 25;
      if (this.users.length >= 75) {
        this.currentPageTop++;
      }
      this.currentPageBot++;

      let queryParams = {
        pageNumber: this.currentPageBot,
        paginate: this.pagination,
        userType: this.userType,
      };

      if (this.search !== null) {
        queryParams["search"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      const usersObject = await this.fetchAllUsers(queryParams);
      this.lastPage = usersObject.data.meta.last_page;
      const allUsers = [...this.users, ...usersObject.data.data];
      this.users = Array.from(new Set(allUsers.map(a => a.id)))
      .map(id => { return allUsers.find(a => a.id === id) })
      if (this.users.length > 75) {
        this.users = this.users.slice(this.users.length - 75);
      }
      this.users.forEach(user => {
        user.name = user.first_name + ' ' + user.last_name;
        user.status = user.status ? 'Active' : 'Not Active';
        user.role_name = user.role.name ? user.role.name : 'No Role';
        this.userType = user.type;
      });

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 2; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll - offset,
            behavior: "smooth",
          });
        }
      }
    },

    async getMaterialsTop() {
      this.loading = true;
      this.pagination = 25;
      this.currentPageTop--;

      let queryParams = {
        "page[number]": this.currentPageTop,
        paginate: this.pagination,
        material_family_id: this.materialFamily,
      };

      if (this.search !== null) {
        queryParams["filter[search]"] = this.search;
      }

      if (this.sortOrder !== null) {
        queryParams["sort"] = this.sortOrder;
      }

      const usersObject = await this.fetchAllUsers(queryParams);
      this.lastPage = usersObject.data.meta.last_page;
      const allUsers = [...usersObject.data.data, ...this.users];
      this.users = Array.from(new Set(allUsers.map(a => a.sm_id)))
        .map(id => { return allUsers.find(a => a.sm_id === id) })
      if (this.users.length > 75) {
        this.users.splice(-(this.materials.length - 75));
        this.currentPageBot--;
      }
      this.users.forEach(user => {
        user.name = user.first_name + ' ' + user.last_name;
        user.status = user.status ? 'Active' : 'Not Active';
        user.role_name = user.role.name ? user.role.name : 'No Role';
        this.userType = user.type;
      });

      const currentScroll = document.getElementById("scroll-bar").scrollTop;
      this.loading = false;

      const rowElement = document.getElementById("rowId");
      if (rowElement) {
        const rowHeight = rowElement.clientHeight;
        for (let i = 0; i < 25; i++) {
          const offset = rowHeight * i;
          document.getElementById("scroll-bar").scrollTo({
            top: currentScroll + offset,
            behavior: "smooth",
          });
        }
      }
    },

    // onCheckboxClick(event) {
    //   this.selectedRows = event.map(row => ({ uuid: row.sm_uuid }));
    // },

    handleSearch: _.debounce(function (event) {
      if (event === "") {
        this.search = null;
      } else {
        this.search = event;
      }
      this.users = [];
      this.getInitialUsers();
    }, 1000),

    onScrollBottom() {
      if (this.currentPageBot !== this.lastPage) {
        this.pageNumber++;
        this.getUsersBottom();
      }
    },

    onScrollTop() {
      if (this.currentPageTop !== 1) {
        this.pageNumber--;
        this.getMaterialsTop();
      }
    },

    onSortClick(sortOrder, index) {
      this.users = []
      if (sortOrder === "asc") {
        this.sortOrder = this.headers[index].varName;
      } else if (sortOrder === "desc") {
        this.sortOrder = `-${this.headers[index].varName}`;
      } else {
        this.sortOrder = sortOrder;
      }
      this.getInitialUsers();
    },

    async handleDelete() {
      try {
        await this.DELETE_USER_BY_ID(this.selectedUser.id);
      } catch (error) {
        console.error(error);
      } finally {
        bus.$emit("clear-SelectedItems")
        this.$emit('clear-selected-item')
        this.deleteDialogIsOpen = false;
        this.getAvailableUsers();
        this.getInitialUsers();
      }
    },

    async handleDownload() {
      try {
        let data = await this.downloadAll();
        window.open(data.file_url_public);
      } catch (e) {
        console.error(e);
      }
    },

    handleCloudDownload() {
      this.dialog = true;
    },

    handleAdd() {
      this.$emit('open-create-user-form')
      this.getAvailableUsers();
      this.getInitialUsers();
      // bus.$emit("create-new-user")
    },

    handleTabChange(index) {
      this.getAvailableUsers();
      this.activeTab = index;
      this.$emit('change-tab', this.tabs[index].value);
      bus.$emit("clear-SelectedItems")
      this.selectedRows = [];
      if (this.activeTab === 0) {
        this.users = this.availableWebUsers;
        this.userType = 'web'
        this.getInitialUsers();
      } else if (this.activeTab === 1) {
        this.users = this.availableMobileUsers;
        this.userType = 'mobile'
        this.getInitialUsers();
      } else if (this.activeTab === 2) {
        this.users = this.availableWebViewerUsers;
        this.userType = 'web viewer'
        this.getInitialUsers();
      } else if (this.activeTab === 3) {
        this.users = this.availableMobileViewerUsers;
        this.userType = 'mobile viewer'
        this.getInitialUsers();
      }
    },

    openDeleteDialog() {
        this.deleteDialogIsOpen = true;
    },
  },
};
</script>

<style scoped>
.searchContainer {
  display: flex;
  align-items: center;
}

.tableDivContainer {
  height: 87%;
  margin-top: 5px;
}

.tabsContainer {
  height: 8%;
  display: flex;
  margin-top: 5px;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  text-transform: uppercase;
}

.rightSideTitleActions {
  height: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.buttons-container-custom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 20px;
}

.cancel-button-custom {
  background: transparent;
  border-radius: 0.25rem;
  border: 0.609px solid #29bdf0;
}

.leftCardContainer {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 20px 28px;
}

.actionsContainer {
  display: flex;
  align-items: center;
  gap: 3px;
}

.leftTitle {
  color: #767676;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
  line-height: 20px;
  /* 200% */
  text-transform: uppercase;
}

.rightSideTitleActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.layer-search {
  flex: 0 0 auto;
  font-size: 12px;
  margin-right: 5px;
}

.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}

.span-custom {
  display: flex;
  padding: 0px 20px;
  color: #767676;
  font-family: Lato;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}

.tabs-custom {
  padding: 0px 20px;
}

.table-custom {
  height: 90%;
}

.table-buttons-custom {
  height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/Accounts/TableView.vue